export interface LoaderDotsProps {
    classNames?: string;
}

export const LoaderDots = ({ classNames = '' }: LoaderDotsProps) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 24" className={`${classNames}`} aria-hidden="true">
            <rect x="1" y="10" width="5" height="5" rx="1" className="animate-loaderPulse origin-center [transform-box:fill-box]" />
            <rect x="11" y="10" width="5" height="5" rx="1" className="animate-loaderPulse origin-center [transform-box:fill-box] [animation-delay:.08s]" />
            <rect x="21" y="10" width="5" height="5" rx="1" className="animate-loaderPulse origin-center [transform-box:fill-box] [animation-delay:.16s]" />
        </svg>
    );
};
